import { createConnector } from 'react-instantsearch-core';
import { bool } from 'prop-types';
import { multipleFiltersAttributesShape } from 'shapes';
import {
    isFacetRefinementMissing,
    getClearedSearchState,
    addAttributesToSearchParameters,
    updateRefinementsToSearchParameters,
    getCurrentRefinements,
    getRefinedSearchState,
    areMissingAttributesInSearchParameters,
} from './utils';

export default createConnector({
    displayName: 'connectMultipleFilters',

    propTypes: {
        attributes: multipleFiltersAttributesShape.isRequired,
        replaceAttributeValues: bool, // if true, old values will be erased otherwise they will be merged
        replaceSearchState: bool, // if true, replace all of the old algolia state
    },

    defaultProps: {
        replaceAttributeValues: true,
        replaceSearchState: false,
    },

    getProvidedProps(props, searchState) {
        const { attributes } = props;
        return {
            currentRefinements: getCurrentRefinements(searchState, attributes),
        };
    },

    refine(props, searchState, nextRefinements, clearRefinements) {
        const clearedSearchState = getClearedSearchState(searchState, {
            ...props,
            clearRefinements,
        });

        return getRefinedSearchState(
            props,
            clearedSearchState,
            nextRefinements,
        );
    },

    getSearchParameters(searchParameters, props, searchState) {
        let nextSearchParameters = searchParameters;
        const { attributes } = props;

        if (
            areMissingAttributesInSearchParameters(
                nextSearchParameters,
                attributes,
            )
        ) {
            nextSearchParameters = addAttributesToSearchParameters(
                nextSearchParameters,
                attributes,
            );
        }

        if (
            isFacetRefinementMissing(
                nextSearchParameters,
                searchState,
                attributes,
            )
        ) {
            nextSearchParameters = updateRefinementsToSearchParameters(
                nextSearchParameters,
                searchState,
                attributes,
            );
        }
        return nextSearchParameters;
    },

    cleanUp(props, searchState) {
        return searchState;
    },
});
